import React, {useCallback, useState, useEffect} from 'react';
import {useDropzone} from 'react-dropzone';
import Spinner from '../Spinner/Spinner';

import * as S from './Uploader.styles';

const Uploader = ({setFiles, onChange, uploadedFiles = []}) => {
  const [isUploading, setIsUploading] = useState(false);

  const onDrop = useCallback(
    acceptedFiles => {
      setIsUploading(true);
      setIsUploading(false);
      onChange?.(acceptedFiles);
      setFiles?.(acceptedFiles);
    },
    [uploadedFiles],
  );

  const {acceptedFiles, getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    accept: {
      'image/png': ['.png'],
      'image/jpg': ['.jpg'],
      'image/jpeg': ['.jpeg'],
      'application/pdf': ['.pdf'],
    },
    maxFiles: 1,
  });

  const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return false;

    const byte = 1000000;
    const maxData = 3 * byte;

    if (bytes <= maxData) return false;
    return true;
    /*const k = 1024

        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`*/
  };

  const removeFile = file => () => {
    onChange?.([]);
    setFiles?.([]);
  };

  const setIcon = obj => {
    switch (obj.type) {
      case 'image/png':
        return <span className="sprite icImage"></span>;
        break;
      case 'image/jpg':
        return <span className="sprite icImage"></span>;
        break;
      case 'image/jpeg':
        return <span className="sprite icImage"></span>;
        break;
      case 'application/pdf':
        return <span className="sprite icPdf"></span>;
        break;
      default:
        <span className="sprite icImage"></span>;
        break;
    }
  };

  const files = uploadedFiles?.map(file => (
    <S.UploadedFileItemCont key={file.path}>
      <S.UploadedFileItem isError={formatBytes(file.size)}>
        <S.FilteTypeIcon>{setIcon(file)}</S.FilteTypeIcon>
        <S.UploadedFileItemDesc>
          <S.FileName>{file.path}</S.FileName>
          <S.FileSize>{formatBytes(file.size)}</S.FileSize>
        </S.UploadedFileItemDesc>
        <span className="sprite icMinus" onClick={removeFile(file)}>
          X
        </span>
      </S.UploadedFileItem>
      {formatBytes(file.size) && (
        <S.ErrorMsg>File {file.path} could not be upload. File exceeds size limit.</S.ErrorMsg>
      )}
    </S.UploadedFileItemCont>
  ));

  return (
    <S.UploadWrapper>
      <S.UploadContent>
        <S.UploadCont {...getRootProps()} multiple={false}>
          <input {...getInputProps()} />
          <h4>Upload your proof of Payment!</h4>
          <S.Description>
            Please upload a screen shot of your bank statement with UTR transaction in{' '}
            <span>PNG</span>, <span>JPEG</span> or <span>PDF</span> format. Not larger than 3MB in
            size.
          </S.Description>
          <S.Drag>
            <span className="sprite icUpload" />
            Drag and drop
          </S.Drag>
          <S.Or>- OR -</S.Or>
          <S.SelectBtn type="button" disabled={isUploading}>
            {isUploading && <Spinner theme="blue" />} Select from your computer
          </S.SelectBtn>
        </S.UploadCont>
        {uploadedFiles.length > 0 && files}
      </S.UploadContent>
      <S.Info>Note: Mandatory field, to help help us validate faster.</S.Info>
    </S.UploadWrapper>
  );
};

export default Uploader;
